// extracted by mini-css-extract-plugin
module.exports = {"product":"H_cy","product__image":"H_cz","product__featured":"H_cB","product__prices":"H_cC","product__prices__sale":"H_cD","product__title":"H_cF","product__title__sale":"H_cG"};